import { useSelector } from 'react-redux';
import Session, {
  APPLICATION_NAME,
  IS_BUYSIDE,
  IS_LO,
} from '../../../common/services/Session';
import {
  useLoanDataFieldSelector,
  useLoanInformationField,
  useUserData,
} from '../../../data/useSelectors';
import { HeaderMenu } from './HeaderMenu';
import { OnrpLimitNotificationHeader } from './HeaderMenu/LockDeskStatus/components/OnrpLimitNotificationHeader';
import { PricingNotificationHeader } from './PricingNotificationHeader';
import { SmartClientHeader } from './SmartClientHeader';
import { WarningProgramStatus } from './WarningProgramStatus';

export const Header = () => {
  const { loanId } = useSelector(({ EPPS }) => EPPS.loanPrograms || {});
  const { firstName = '', lastName = '', office = '' } = useUserData();
  const loanNumber = useLoanInformationField('loanNumber', '') as string;
  const loanIdLoanData = useLoanInformationField('loanId');
  const loanChannel = useLoanDataFieldSelector(
    'loanInformation.loanChannel',
  ) as unknown as number;
  const displayedLoanId = loanId || loanIdLoanData;
  const username = `${firstName} ${lastName}`;
  const isBuyside = Session.get(IS_BUYSIDE);
  const isValidChannel = [0, 1].includes(loanChannel);
  const isVisibleLockDesk = isValidChannel && !isBuyside;

  const applicationName = Session.get(IS_LO)
    ? Session.get(APPLICATION_NAME) || 'ENCW'
    : 'EPPS';

  return (
    <>
      {applicationName === 'ENC' ? (
        <SmartClientHeader
          loanId={displayedLoanId}
          username={username}
          office={office}
          loanNumber={loanNumber}
        />
      ) : (
        <HeaderMenu
          loanId={displayedLoanId}
          applicationName={applicationName}
        />
      )}
      <PricingNotificationHeader />
      {isVisibleLockDesk && <OnrpLimitNotificationHeader />}
      {isBuyside && <WarningProgramStatus />}
    </>
  );
};
